export default __webpack_public_path__ + "static/media/icono-notificacion.00535419.png";